export { default } from "./ProductInformationTab";
